import React from 'react';
import {makeStyles} from "@material-ui/core/styles/index";
import Typography from '@material-ui/core/Typography'
import Grid from "@material-ui/core/es/Grid/Grid";
import { gql, useQuery } from '@apollo/client';

const useStyles = makeStyles((theme) => {
    return {
        root: {
            marginTop: 50,
            paddingBottom: 40,
            ['@media (max-width:500px)']: {
                marginTop: 30,
                paddingBottom: 20,
                borderBottom: 'none',
            },
        },
        h4: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            fontSize: '1.5rem',

            width: 447,
            marginLeft: 'auto',
            marginRight: 'auto',
            ['@media (max-width:500px)']: {
                marginLeft: 15,
                width: 'auto',
            }
        },
        grid: {
            maxWidth: 1000,
            ['@media (max-width:1000px)']: {
                maxWidth: '95%',
            },
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: 20,
            ['@media (max-width:500px)']: {
                marginTop: 0,
            },
            '& h5': {
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: 400,
                fontSize: '1.1rem',
                marginTop: 20,
                marginBottom: 10,
                ['@media (max-width:500px)']: {
                    marginTop: 15,
                    marginBottom: 5,
                }
            },
            '& a': {
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: 400,
                fontSize: '1.1rem',
                ['@media (max-width:500px)']: {
                    fontSize: '.9rem',
                },
                textDecoration: 'none',
                color: '#000055',
                '&:hover': {
                    textDecoration: 'underline',
                }
            },
            '& p': {
                ['@media (max-width:500px)']: {
                    fontSize: '.8rem'
                }
            }
        },

    }}
);

const GET_DATA = gql`
    query {
        getPopularCars {
            items
        }
    }
`;

export default function PopularCars(props) {
    const classes = useStyles();

    const {data} = useQuery(GET_DATA);

    if (!data) {
        return null;
    }

    const cells = props.screenWidth <= 500 ? 2 : 3;

    const size = 12/cells;

    const cars = data.getPopularCars ? JSON.parse(data.getPopularCars.items) : null;

    if (!cars) {
        return;
    }

    return (
        <div className={classes.root}>
            <h4 className={classes.h4}>View inventory</h4>
            <Grid container spacing={1} className={classes.grid}>
            {cars.map(car => {
                const title = 'Used '+car[0]+' '+car[1];
                return <Grid item md={size} sm={size} xs={size}>
                    <h5><a href={"/used-cars/"+car[0]+','+car[1]} title={title}>{title}</a></h5>
                    <Typography>{car[2]} vehicles starting at {car[3]}</Typography>
                </Grid>
            })}
            </Grid>

        </div>
    );
}
